import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../api";
import apiFunctions from "../../../api/functions.js";

import { Row, Col, Label, Input, InputGroup, FormFeedback, Table } from "reactstrap";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";

import moment from "moment";
import { format, formatCurrency } from "../../../functions/functions";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,

            loteoNombre: '',
            loteNombre: '',
            tipo: '',
            monto: 0,

            movimientos: [],

            postVariables: [],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(["CREATE", "EDIT", "DETAIL", "DELETE"])
            .isRequired,
    };

    resetForm() {
        this.setState({
            id: null,

            loteoNombre: '',
            loteNombre: '',
            tipo: '',
            monto: 0,

            movimientos: [],

            errors: [],
        });
    }

    getData() {
        const { postVariables, fecha } = this.state;
        let data = {};
        postVariables.forEach((x) => {
            data[x] = this.state[x];
        });
        data.fecha = fecha.format("YYYY-MM-DDThh:mm");

        return data;
    }

    setData(data) {
        const { action } = this.props;

        if (data.data) {
            this.setState({
                movimientos: data.data,
                monto: (data.monto) ? (data.monto) : (0),
            });
        }
        
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState((prevState) => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;

        if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Movimiento De Lote",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: () => (this.props.row() ? 0 : false),
                loteo_id: this.props.row() ? this.props.row().loteo_id : null,
                lote_id: this.props.row() ? this.props.row().lote_id : null,
                tipo: this.props.row() ? this.props.row().tipo : null,
            };
        }
    }

    onOpen = () => {
        if(this.props.row()){
            this.setState({
                loteoNombre: this.props.row().loteoNombre,
                loteNombre: this.props.row().loteNombre,
                tipo: this.props.row().tipo,
            })
        }
    }

    render() {
        const { movimientos, loteoNombre, loteNombre, monto, tipo } = this.state;
        let vars = this.modalVars();

        let subtotal = 0;

        return (
            <ParadigmaModal
                getUrl={
                    vars.get && vars.loteo_id && vars.lote_id && vars.tipo
                        ? api.caja.movimientosAgrupados +
                          vars.loteo_id +
                          "/" +
                          vars.lote_id +
                          "/" +
                          vars.tipo +
                          "/"
                        : null
                }
                // submitUrl={(vars.submitType ? api.caja.movimientosAgrupados : null)}
                submitType={vars.submitType}
                id={null}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onOpen={() => this.onOpen()}
                onPreSubmit={() => this.getData()}
                title={vars.title}
                danger={vars.danger}
                buttonClass={vars.buttonClass}
                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className={'modal-lg'}
            >
                {(vars.get && vars.loteo_id && vars.lote_id && vars.tipo) ?
                <Fragment>
                    <Row className={'mt-2 mb-3'}>
                        <Col xs={"6"}>
                            <Label className={'lbl_movDetalle'}><span>{'Loteo: '}</span>{loteoNombre}</Label>
                        </Col>
                        <Col xs={"6"}>
                            <Label className={'lbl_movDetalle'}><span>{'Lote: '}</span>{loteNombre}</Label>
                        </Col>
                        <Col xs={"6"}>
                            <Label className={'lbl_movDetalle'}><span>{'Tipo: '}</span>{((tipo=='VE') ? ('Venta') : ((tipo=='SE') ? ('Servicio') : ('Escritura')))}</Label>
                        </Col>
                        <Col xs={"6"}>
                            <Label className={'lbl_movDetalle'}><span>{'Monto: '}</span>{'$ '+formatCurrency(monto)}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h4 className={'d-block text-center'}> Movimientos </h4>
                            <Table size="sm" hover>
                                <thead>
                                    <tr className={'text-center'}>
                                        <th>Fecha</th>
                                        <th>Caja</th>
                                        <th>Cuenta</th>
                                        <th>Ingreso</th>
                                        <th>Egreso</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {movimientos.map((d, i) => {
                                        subtotal += (d.ingresos-d.egresos);
                                        return <tr key={i}>
                                            <td>{moment(d.fecha).format('DD-MM-YYYY')}</td>
                                            <td>{d.caja_nombre}</td>
                                            <td>{d.cuenta_nombre}</td>
                                            <td className={'text-right'}>{'$ '+formatCurrency(d.ingresos)}</td>
                                            <td className={'text-right'}>{'$ '+formatCurrency(d.egresos)}</td>
                                            <td className={'text-right'}>{'$ '+formatCurrency(subtotal)}</td>
                                        </tr>
                                    })}
                                    {movimientos.length === 0 && (
                                        <tr>
                                            <td className="text-center" colSpan={3}>
                                                No hay movimientos
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={'ml-auto col-4'}>
                            <Label className={'lbl_movDetalle'}><span>{'Total Cobrado: '}</span>{'$ '+formatCurrency(subtotal)}</Label>
                        </Col>
                    </Row>
                </Fragment>
                :
                <Row>
                    <Col className={'text-center'}>
                        <h3>Los movimientos no tienen asignado un lote</h3>
                    </Col>
                </Row>}
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosAgrupados/ModalDetalle.js